require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-hazeldellribboncutting.json") })
        }
      }, "path---es-articles-hazeldellribboncutting");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-hazeldellribboncutting!./.cache/json/es-articles-hazeldellribboncutting.json
// module id = 2207
// module chunks = 231608221292675